import e from"../createTheme/createTheme.js";function t(e){return"ownerState"!==e&&"theme"!==e&&"sx"!==e&&"as"!==e}e();export{t as shouldForwardProp};
//# sourceMappingURL=createStyled.js.map
